import React, { useEffect, useState } from 'react'

export default function VerificationButton({status}) {

    const [img, setImg] = useState('');
    const [text, setText] = useState('');

    useEffect(() => {
        if(status === 'verified'){
            setImg('verified');
            setText('Verified');
            document.getElementById('varifyButton').classList.remove('verification-pending')
            document.getElementById('varifyButton').classList.add('verification-verified')
            document.getElementById('varifyButton').classList.remove('verification-start') 
        } else if (status == 'pending'){
            setImg('alert');
            setText('Pending Verification');
            document.getElementById('varifyButton').classList.add('verification-pending')
            document.getElementById('varifyButton').classList.remove('verification-verified')
            document.getElementById('varifyButton').classList.remove('verification-start')
        } else {
            setText('Start Verification');
            document.getElementById('varifyButton').classList.remove('verification-pending')
            document.getElementById('varifyButton').classList.remove('verification-verified')
            document.getElementById('varifyButton').classList.add('verification-start')
        }
    }, [status])

    return (
        <div id='varifyButton' className='verification-verified'>
            {img ? <img src={require(`../../assets/icons/${img}.svg`)} /> : ''}
            <p>{text}</p>
        </div>
    )
}
